<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">정기권 주차장관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">정기권 주차장 관리</h3>
        <article>
          <div class="selectOpt type04">
            <dl>
              <dt>
                <h4 class="tit">주차장명 조회</h4>
              </dt>
              <dd>
                <input
                  type="text"
                  v-model="searchKeyword"
                  @keyup.enter="searchBtn"
                  title="주차장명 입력"
                  class="middle"
                  placeholder="주차장명 입력"
                />
              </dd>
              <dd>
                <div class="flex">
                  <date-picker :sDateTime="sDateTime" @emitSDate="emitSDate" /><span class="at web"
                    >&nbsp; - &nbsp;</span
                  >
                  <date-picker :eDateTime="eDateTime" @emitEDate="emitEDate" /><button
                    type="button"
                    @click="setDate"
                    class="btn purple"
                  >
                    선택건 적용
                  </button>
                </div>
              </dd>
            </dl>
          </div>
          <div class="flexRow">
          <p class="info" style="margin: 30px 0 15px">
            조회된 주차장은 1개입니다. 변경을 원하시는 주차장에 체크하신 후 신청기간을 설정한 뒤 적용 버튼을 눌러주세요.
          </p>
          <button type="button" @click="reload" class="btn refresh">다시 불러오기</button>
          </div>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <table>
                <caption>
                  정기권 주차장 관리 테이블
                </caption>
                <thead>
                  <tr>
                    <th scope="col">
                      <p class="checkbox">
                        <input type="checkbox" id="chk-on" class="hidden" v-model="allChecked" @click="checkedAll" />
                        <label for="chk-on"></label>
                      </p>
                    </th>
                    <th scope="col">번호</th>
                    <th scope="col">주차명 명</th>
                    <th scope="col">신청 기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="nodate" v-if="nodata">
                    <td colspan="8">조회된 데이터가 없습니다.</td>
                  </tr>
                  <tr v-for="(item, index) in listData" :key="index">
                    <td>
                      <p class="checkbox" @change="checkboxCkc()">
                        <input
                          type="checkbox"
                          :id="'itemCheck_' + item.PARKING_NM"
                          v-model="checkedValues"
                          :value="index"
                        />
                        <label :for="'itemCheck_' + item.PARKING_NM"></label>
                      </p>
                    </td>
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.PARKING_NM }}</td>
                    <td>{{ item.START_DTTM }} - {{ item.END_DTTM }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--btnArea-->
          <div class="btnArea">
            <button type="button" @click="insertParkingInfo" class="btn blue">변경정보 저장</button>
          </div>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import DatePicker from '../../../components/DatePicker1.vue';

export default {
  data() {
    return {
      listData: [],
      searchKeyword: '',
      nodata: true,
      checkedValues: [],
      allChecked: false,
      selectList: [],
      sDateTime: {
        sDate: '',
        sTime: '',
      },
      eDateTime: {
        eDate: '',
        eTime: '',
      },
    };
  },

  components: {
    DatePicker,
  },

  mounted() {
    this.searchBtn();
  },

  methods: {
    async reload() {
      const res = await axios('get', '/api/admin/period/manager/insertParkingInfo.json');
      if(res.status / 100 != 2) {
        alert('불러오기에 실패하였습니다. 다시 시도해주세요.');
        return;
      }
      if(res.data.message.includes('정상')) {
        alert('주차장 정보를 갱신하였습니다.');
        this.searchBtn();
      }
    },

    checkedAll() {
      if (!this.allChecked) {
        this.checkedValues = [];
        this.listData.forEach((element, index) => {
          this.checkedValues.push(index);
        });
      } else {
        this.checkedValues = [];
      }
    },

    checkboxCkc() {
      if (this.listData.length === this.checkedValues.length) {
        this.allChecked = true;
        return;
      }
      this.allChecked = false;
    },

    async searchBtn() {
      const res = await axios('get', '/api/admin/period/manager/selectPeriodParkingListByKeyword.json', {
        searchKeyword: this.searchKeyword,
      });
      if (!res.data.value || res.data.value.length <= 0) {
        this.listData = [];
        this.nodata = true;
        return;
      }
      this.listData = res.data.value;
      this.nodata = false;
    },

    setDate() {
      if (this.sDateTime.sTime == '' || this.eDateTime.eTime == '') {
        alert('시간 설정 후 다시 시도해주세요.');
        return;
      }
      for (const i of this.checkedValues) {
        this.listData[i].START_DTTM = this.sDateTime.sDate + ' ' + this.sDateTime.sTime;
        this.listData[i].END_DTTM = this.eDateTime.eDate + ' ' + this.eDateTime.eTime;
      }
      alert('시간이 설정 되었습니다.');
      // this.checkedValues = [];
    },
    emitSDate(DateTime) {
      this.sDateTime = DateTime;
    },
    emitEDate(DateTime) {
      this.eDateTime = DateTime;
    },

    async insertParkingInfo() {
      const apiParams = new FormData();

      const endDttm = [],
        sectnId = [],
        startDttm = [],
        periodAllotType = [];

      for (const i of this.listData) {
        endDttm.push(i.END_DTTM);
        sectnId.push(i.SECTN_ID);
        startDttm.push(i.START_DTTM);
        periodAllotType.push(i.PERIOD_ALLOT_TYPE);
      }
      apiParams.append('endDttm', endDttm);
      apiParams.append('sectnId', sectnId);
      apiParams.append('startDttm', startDttm);
      apiParams.append('periodAllotType', periodAllotType);

      const res = await axios('post', '/api/admin/period/manager/updatePeriodParking.json', apiParams);
      if (res) {
        alert('적용되었습니다.');
        this.checkedValues = [];
        this.allChecked = false;
      } else {
        alert('저장 되지 않았습니다.');
      }
    },
  },
};
</script>
